import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 好看的韩国漫画在线免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-2">{comic.description}</p>
        </div>
        <div className="absolute top-2 left-2">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium ${
              comic.status === '连载中'
                ? 'bg-accent-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="flex items-center gap-0.5 text-xs text-accent-600">
            <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center"></i>
            {comic.rating}
          </span>
          <span className="text-xs text-foreground-400">共{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}